'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _datamap = require('./datamap');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_datamap).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-datamaps/lib/index.js
 ** module id = 238
 ** module chunks = 0
 **/